<template>
    <div id="list-sizesImages-component" class="w-full">
        <custom-simple-select
            v-model="imageSize"
            label="Tamaños de imágenes"
            class="w-full"
            :options="imageSizeOptions"
            :disabled="!enabled"
            @change="onInput"
        />
    </div>
</template>

<script>
import { sizesImages } from "@/common/fields/sizes-images";

import CustomSimpleSelect from "@/components/utils/CustomSimpleSelect.vue";

export default {
    name: "ImageSizeSelector",
    components: { CustomSimpleSelect },
    model: {
        prop: "itemCurrent",
        event: "change"
    },
    props: {
        itemCurrent: {
            default: () => "squareImage",
            type: String,
            require: true
        },
        enabled: {
            default: () => true,
            type: Boolean,
            required: false
        }
    },
    emits: ["change"],
    data: () => ({
        imageSize: "squareImage",
        $sizesImages: sizesImages
    }),
    computed: {
        imageSizeOptions() {
            return this.$sizesImages.map((item) => ({
                label: `${item.title} | ${item.width} x ${item.height}`,
                value: item.size
            }));
        }
    },
    watch: {
        itemCurrent(itemCurrent) {
            this.imageSize = itemCurrent;
        }
    },
    mounted() {
        this.imageSize = this.itemCurrent;
    },
    methods: {
        onInput(value) {
            this.$emit("change", value);
        }
    }
};
</script>
